import { createApp } from "vue";
import store from "../../common/js/store";
import registerServiceWorker from "./serviceWorkerRegistration";

// Global components import
import ThankYou from "../../common/js/components/ThankYou.vue";
import Help from "../../common/js/components/Help.vue";

const app = createApp({});
app.use(store);

// Global components registration
// @todo: similarly all other components registration currently inside Home.vue will move here and Home.vue will be discarded
app.component("thank-you", ThankYou);
app.component("help", Help);

app.mount("#themeDefaultThankYou");

// @todo : uncomment this...

registerServiceWorker();

if (typeof window != "undefined") {
  window.onbeforeunload = () => {
    window.scrollTo(0, 0);
  };
}
